"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_sortable_hoc_1 = require("react-sortable-hoc");
var Item_1 = __importDefault(require("./Item"));
var SortableItem = (0, react_sortable_hoc_1.SortableElement)(function (_a) {
    var id = _a.id, checked = _a.checked, label = _a.label, isStatic = _a.isStatic, onChangeColumn = _a.onChangeColumn;
    return (react_1.default.createElement(Item_1.default, { id: id, checked: checked, label: label, isStatic: isStatic, onChangeColumn: onChangeColumn }));
});
exports.default = SortableItem;
